// App-icon badge for installed PWAs (iOS 16.4+ home-screen apps, Android/Chrome).
// Combines unread counts from independent sources so the icon bubble shows the
// total of unread messages + notifications, and clears when both reach zero.

type BadgeSource = 'messages' | 'notifications';

const counts: Record<BadgeSource, number> = {
  messages: 0,
  notifications: 0,
};

function applyBadge() {
  const nav = navigator as Navigator & {
    setAppBadge?: (count?: number) => Promise<void>;
    clearAppBadge?: () => Promise<void>;
  };
  if (typeof nav.setAppBadge !== 'function') return;

  const total = counts.messages + counts.notifications;
  if (total > 0) {
    nav.setAppBadge(total).catch(() => {});
  } else {
    nav.clearAppBadge?.().catch(() => {});
  }
}

export function setBadgeCount(source: BadgeSource, count: number) {
  const next = Math.max(0, count);
  if (counts[source] === next) return;
  counts[source] = next;
  applyBadge();
}

export function resetAppBadge() {
  counts.messages = 0;
  counts.notifications = 0;
  applyBadge();
}
